// extracted by mini-css-extract-plugin
export default {"product-image":"manageProductsEdit_product-image__5OvSV"};